import { jsx as _jsx } from "react/jsx-runtime";
import { validationPatterns } from "@jti/ui/utils/validationPatterns";
import { CascadingSelect } from "../cascading-select/CascadingSelect";
import Checkbox from "../checkbox/Checkbox";
import ConsentCheckbox from "../consent-checkbox/ConsentCheckbox";
import Input from "../input/Input";
import Select from "../select/Select";
import Textarea from "../textarea/Textarea";
export const FormElement = ({ item, formConfig, disabled = false }) => {
    const { resourceName, validation, matchFieldId, required, maxLength, minLength, ...props } = item;
    const componentName = resourceName?.split("/").pop();
    const patterns = {
        email: validationPatterns.EMAIL_PATTERN,
        phone: validationPatterns.PHONE_CONTACT_FORM_REGEX,
    };
    const matchFieldValidation = {
        ...(matchFieldId && {
            validate: (value) => value === formConfig?.getValues(matchFieldId),
        }),
    };
    const validationRules = {
        required,
        maxLength: maxLength ? Number(maxLength) : undefined,
        minLength: minLength ? Number(minLength) : undefined,
        pattern: validation ? { value: patterns[validation], message: "" } : undefined,
        ...matchFieldValidation,
    };
    const inputConfig = { formConfig, validationRules, ...props };
    switch (componentName) {
        case "checkbox":
            return _jsx(Checkbox, { ...inputConfig });
        case "consentcheckbox":
            return _jsx(ConsentCheckbox, { ...inputConfig });
        case "textarea":
            return _jsx(Textarea, { ...inputConfig });
        case "dropdown":
        case "reasons":
            return _jsx(Select, { ...inputConfig });
        case "cascadedropdowns":
            return _jsx(CascadingSelect, { ...inputConfig });
        case "textinput":
        case "input":
        default:
            return _jsx(Input, { ...inputConfig, type: validation, disabled: disabled });
    }
};
//# sourceMappingURL=FormElement.js.map